import * as React from 'react';
import { useSelector } from 'react-redux';

import * as style from './index.css';
import { IAppState } from '../../common/state';
import { AdfoxContextData } from '../../types/adfox/AdfoxContextData';
import { AdfoxContextProvider, PParams } from '../../utils/AdfoxContext';
import { useApplicationContext } from '../../utils/applicationContext';
import { AdFoxBanner } from '../AdfoxBanner';

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Если группа эксперимента A победит, то оставить, но переименовать в SeoTopBanners и удалить комментарий
 * Если группа A не победит, тогда удалить функцию целиком
 */
const SeoTopBannersA: React.FC = () => {
  const postViewAnalyticsData = React.useMemo<AdfoxContextData['postViewAnalyticsData']>(
    () => ({
      banner: {
        place: 'offersSerp',
        name: 'Listing_footer_TGB',
        extra: {
          offerType: 'TGB_banner',
        },
      },
    }),
    [],
  );

  const pParams = React.useMemo<PParams>(() => ({ p1: 'cqvyb', p2: 'fkhh' }), []);

  const size = React.useMemo<AdfoxContextData['size']>(() => ({ width: '100%', minHeight: '200px' }), []);

  const banners = [1, 2, 3].map(id => {
    return <AdFoxBanner key={id} position={id} />;
  });

  return (
    <div className={style['container']} data-name="SeoTopBannersA">
      <AdfoxContextProvider size={size} pParams={pParams} postViewAnalyticsData={postViewAnalyticsData}>
        {banners}
      </AdfoxContextProvider>
    </div>
  );
};

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Если группа эксперимента B победит, то оставить, но переименовать в SeoTopBanners и удалить комментарий
 * Если группа B не победит, тогда удалить функцию целиком
 */
export const SeoTopBannersB: React.FC = () => {
  const pParams = React.useMemo<PParams>(() => ({ p1: 'dbtyp', p2: 'y' }), []);

  const size = React.useMemo<AdfoxContextData['size']>(() => ({ width: '100%', minHeight: '395px' }), []);

  return (
    <div
      /**
       * @todo Переименовать селектор с экспериментом
       * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
       * Переименовать в container, подчистить ненужный мусор из css
       */
      className={style['container-b']}
      data-name="SeoTopBannersB"
    >
      <AdfoxContextProvider size={size} pParams={pParams} postViewAnalyticsData={null}>
        <AdFoxBanner position={null} />
      </AdfoxContextProvider>
    </div>
  );
};

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Удалить в любом случае
 */
export const SeoTopBanners: React.FC = () => {
  const subdomain = useSelector((state: IAppState) => state.currentSubdomain);
  const { config } = useApplicationContext();

  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
   * Не забудь забудь удалить из src/node/config.json и src/node/scheme.json
   */
  const newbuildingTestCtrParallaxInTgbFooterEnabled = config.get('Newbuilding.TestCtrParallaxInTgbFooter.Enabled');

  if (newbuildingTestCtrParallaxInTgbFooterEnabled && subdomain === 'spb') {
    return <SeoTopBannersB />;
  }

  return <SeoTopBannersA />;
};
